export default {
    CARD_TOTAL_COST: 'card-total-cost',
    CARD_DOWNLOAD: 'card-download',
    CARD_MONTHS: 'card-months',
    CARD_WEEKS: 'card-weeks',
    CARD_DATES: 'card-dates',
    CARD_PRODUCTS: 'card-products',
    CARD_REGIONS: 'card-regions',
    CARD_STATISTICS: 'card-statistics',
    CARD_BANNER: 'card-banner',
    CARD_BOARD: 'card-board',
    CARD_DATES_DETAIL: 'card-dates-detail',
    SUMMARY_CARD_SIDEBAR: 'summary-card-sidebar',
    SUMMARY_CARD_PRODUCTS: 'summary-card-products',
    SUMMARY_CARD_REGIONS: 'summary-card-regions',
    SUMMARY_CARD_DATES: 'summary-card-dates',
    SUMMARY_CARD_WEEKS: 'summary-card-weeks'
}
